<template>
  <div id="app" class="min-h-screen bg-app-bg font-sans flex flex-col" dir="rtl">
    <!-- Sidebar (shown only when authenticated, email confirmed, not on public quote pages, and not in signup view) -->
    <aside v-if="isAuthenticated && !$route.path.startsWith('/quote/public/') && 
                 isEmailConfirmed && $route.name !== 'signup'" 
           class="fixed inset-y-0 right-0 z-20 bg-sidebar-bg shadow-lg transform transition-transform duration-300 border-l-4 border-sidebar-border" 
           :class="{ 
             'w-64': !sidebarCollapsed, 
             'w-20': sidebarCollapsed, 
             'translate-x-0': sidebarOpen, 
             'translate-x-full': !sidebarOpen,
             'sm:translate-x-0': true
           }">
      <div class="flex items-center justify-between h-16 px-4 border-b">
        <img v-if="!sidebarCollapsed" class="h-28 w-auto" src="@/assets/images/app_logo.png" @click="navigateTo('/qoutes')" alt="לוגו">
        <div class="flex items-center">
          <button @click="toggleSidebarCollapse" class="hidden sm:block p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100">
            <svg v-if="!sidebarCollapsed" class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
            <svg v-else class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
            </svg>
          </button>
          <button @click="toggleSidebar" class="sm:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100">
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      
      <div class="mt-5 px-2 space-y-1">
        
       
        
        <a v-if="isAuthenticated"
          @click.prevent="navigateToQuotes"
          href="#" 
          class="group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer"
          :class="{
            'bg-indigo-50 text-indigo-600': $route.path === '/quotes',
            'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600': $route.path !== '/quotes'
          }">
          <svg xmlns="http://www.w3.org/2000/svg" 
            class="flex-shrink-0 h-6 w-6" 
            :class="{
              'text-indigo-500': $route.path === '/quotes',
              'text-gray-400 group-hover:text-indigo-500': $route.path !== '/quotes',
              'ml-3': !sidebarCollapsed, 
              'mx-auto': sidebarCollapsed
            }" 
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span v-if="!sidebarCollapsed">הצעות מחיר</span>
        </a>
        
        <a v-if="isAuthenticated"
          @click.prevent="navigateTo('/quotes/create')"
          href="#" 
          class="group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer"
          :class="{
            'bg-indigo-50 text-indigo-600': $route.path === '/quotes/create',
            'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600': $route.path !== '/quotes/create'
          }">
          <svg xmlns="http://www.w3.org/2000/svg" 
            class="flex-shrink-0 h-6 w-6" 
            :class="{
              'text-indigo-500': $route.path === '/quotes/create',
              'text-gray-400 group-hover:text-indigo-500': $route.path !== '/quotes/create',
              'ml-3': !sidebarCollapsed, 
              'mx-auto': sidebarCollapsed
            }" 
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          <span v-if="!sidebarCollapsed">יצירת הצעת מחיר</span>
        </a>
        
        <a v-if="isAuthenticated"
          @click.prevent="navigateTo('/products')"
          href="#" 
          class="group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer"
          :class="{
            'bg-indigo-50 text-indigo-600': $route.path === '/products',
            'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600': $route.path !== '/products'
          }">
          <svg xmlns="http://www.w3.org/2000/svg" 
            class="flex-shrink-0 h-6 w-6" 
            :class="{
              'text-indigo-500': $route.path === '/products',
              'text-gray-400 group-hover:text-indigo-500': $route.path !== '/products',
              'ml-3': !sidebarCollapsed, 
              'mx-auto': sidebarCollapsed
            }" 
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4m1.6 8L5 3H3m4 10v6a1 1 0 001 1h10a1 1 0 001-1v-6M9 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM20.5 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
          </svg>
          <span v-if="!sidebarCollapsed">המוצרים שלי</span>
        </a>
        
        <a v-if="isAuthenticated"
          @click.prevent="navigateToAnalytics"
          href="#" 
          class="group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer"
          :class="{
            'bg-indigo-50 text-indigo-600': $route.path === '/analytics',
            'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600': $route.path !== '/analytics'
          }">
          <svg xmlns="http://www.w3.org/2000/svg" 
            class="flex-shrink-0 h-6 w-6" 
            :class="{
              'text-indigo-500': $route.path === '/analytics',
              'text-gray-400 group-hover:text-indigo-500': $route.path !== '/analytics',
              'ml-3': !sidebarCollapsed, 
              'mx-auto': sidebarCollapsed
            }" 
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span v-if="!sidebarCollapsed">סטטיסטיקה</span>
        </a>
        
        <a v-if="isAuthenticated"
          @click.prevent="navigateTo('/dashboard')"
          href="#" 
          class="group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer"
          :class="{
            'bg-indigo-50 text-indigo-600': $route.path === '/dashboard',
            'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600': $route.path !== '/dashboard'
          }">
          <svg xmlns="http://www.w3.org/2000/svg" 
            class="flex-shrink-0 h-6 w-6" 
            :class="{
              'text-indigo-500': $route.path === '/dashboard',
              'text-gray-400 group-hover:text-indigo-500': $route.path !== '/dashboard',
              'ml-3': !sidebarCollapsed, 
              'mx-auto': sidebarCollapsed
            }" 
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span v-if="!sidebarCollapsed">אזור אישי</span>
        </a>
      </div>
      
      <div class="absolute bottom-0 w-full px-4 py-4 border-t">
        <div v-if="isAuthenticated">
          <div v-if="!sidebarCollapsed" class="flex items-center mb-4">
            <div class="h-10 w-10 rounded-full bg-indigo-600 flex items-center justify-center">
              <span class="text-white font-bold">{{ (displayName || 'U')[0].toUpperCase() }}</span>
            </div>
            <div class="mr-3">
              <div class="text-sm font-medium text-gray-700 truncate">{{ displayName }}</div>
            </div>
          </div>
          <div v-else class="flex justify-center mb-4">
            <div class="h-10 w-10 rounded-full bg-indigo-600 flex items-center justify-center">
              <span class="text-white font-bold">{{ (displayName || 'U')[0].toUpperCase() }}</span>
            </div>
          </div>
          <div class="space-y-1">
            <a href="#" 
              @click.prevent="navigateTo('/profile')"
              class="group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer"
              :class="{
                'bg-gray-100 text-indigo-600': $route.path === '/profile',
                'text-gray-600 hover:bg-gray-100': $route.path !== '/profile'
              }">
              <svg xmlns="http://www.w3.org/2000/svg" 
                class="flex-shrink-0 h-5 w-5" 
                :class="{
                  'text-indigo-500': $route.path === '/profile',
                  'text-gray-400': $route.path !== '/profile',
                  'ml-3': !sidebarCollapsed, 
                  'mx-auto': sidebarCollapsed
                }" 
                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span v-if="!sidebarCollapsed">הפרופיל שלי</span>
            </a>
            <button @click="handleSignOut" class="w-full group flex items-center px-2 py-2 text-sm font-medium rounded-md text-red-600 hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 h-5 w-5 text-red-500" :class="{'ml-3': !sidebarCollapsed, 'mx-auto': sidebarCollapsed}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span v-if="!sidebarCollapsed">התנתקות</span>
            </button>
          </div>
        </div>
        <div v-else class="space-y-2">
          <button v-if="!sidebarCollapsed" @click="navigateTo('/login')" class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-md">
            כניסה
          </button>
          <button v-if="!sidebarCollapsed" @click="navigateTo('/signup')" class="w-full bg-white hover:bg-gray-100 text-indigo-600 font-bold py-2 px-4 border border-indigo-600 rounded-md">
            הרשמה
          </button>
          <div v-if="sidebarCollapsed" class="flex flex-col items-center space-y-2">
            <button @click="navigateTo('/login')" class="p-2 rounded-md text-white bg-indigo-600 hover:bg-indigo-700">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
            </button>
            <button @click="navigateTo('/signup')" class="p-2 rounded-md text-indigo-600 border border-indigo-600 hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </aside>
    
    <!-- Mobile sidebar backdrop -->
    <div v-if="sidebarOpen" @click="toggleSidebar" class="fixed inset-0 bg-gray-600 bg-opacity-50 sm:hidden z-10"></div>
    
    <!-- Mobile header (shown only when authenticated, email confirmed, and not in signup view) -->
    <div v-if="isAuthenticated && !$route.path.startsWith('/quote/public/') && 
                isEmailConfirmed && $route.name !== 'signup'" class="sm:hidden fixed top-0 left-0 right-0 z-10 bg-white shadow-md h-16">
      <div class="flex justify-between items-center h-full px-4">
        <img class="h-28 w-auto" src="@/assets/images/app_logo.png" @click="navigateTo('/qoutes')" alt="לוגו">
        <button @click="toggleSidebar" class="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100">
          <svg v-if="!sidebarOpen" class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Toast Notifications -->
    <div v-if="toastMessage" class="fixed top-4 left-4 right-4 z-50">
      <div 
        :class="{
          'bg-green-500': toastType === 'success',
          'bg-red-500': toastType === 'error',
          'bg-blue-500': toastType === 'info',
          'bg-yellow-500': toastType === 'warning',
        }" 
        class="rounded-md p-4 max-w-md mx-auto shadow-lg"
      >
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <svg v-if="toastType === 'success'" class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <svg v-if="toastType === 'error'" class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="mr-3">
            <p class="text-sm font-medium text-white">{{ toastMessage }}</p>
          </div>
          <div class="mr-auto pl-3">
            <button @click="clearToast" class="inline-flex text-white focus:outline-none">
              <span class="sr-only">סגור</span>
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Main content with padding for sidebar when authenticated -->
    <main :class="{ 
      'sm:mr-64': isAuthenticated && !$route.path.startsWith('/quote/public/') && !sidebarCollapsed, 
      'sm:mr-20': isAuthenticated && !$route.path.startsWith('/quote/public/') && sidebarCollapsed,
      'sm:pt-0 pt-16': isAuthenticated && !$route.path.startsWith('/quote/public/'),
      'flex-grow': true 
    }">
      <div :class="{ 'p-4 sm:p-6 lg:p-8': !$route.path.startsWith('/quote/public/') }" class="h-full bg-white shadow-sm">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </main>
    
    <!-- Footer (shown only when authenticated, email confirmed, not on public quote pages, and not in signup view) -->
    <footer v-if="isAuthenticated && !$route.path.startsWith('/quote/public/') && 
                  isEmailConfirmed && $route.name !== 'signup'" class="bg-gray-800 text-white mt-auto" :class="{ 
      'sm:mr-64': !sidebarCollapsed, 
      'sm:mr-20': sidebarCollapsed 
    }">
      <div class="py-6 px-4 sm:px-6 lg:px-8">
        <div class="md:flex md:justify-between">
          <div class="mb-6 md:mb-0">
            <span class="text-lg font-bold">הצעה חכמה</span>
            <p class="mt-2 text-gray-300">© 2025 כל הזכויות שמורות.</p>
          </div>
          <div class="grid grid-cols-2 gap-8 sm:gap-6">
            <div>
              <ul class="text-gray-300">
              </ul>
            </div>
            <div>
              <ul class="text-gray-300">
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { supabase } from './utils/supabaseClient'
import { subscriptionService } from './utils/paypalService'

export default {
  name: 'App',
  data() {
    return {
      mobileMenuOpen: false,
      profileMenuOpen: false,
      sidebarOpen: false,
      sidebarCollapsed: false,
      approvedQuotesCount: 0,
      userDisplayName: null
    }
  },
  computed: {
    ...mapState(['user', 'isLoading', 'toastMessage', 'toastType']),
    ...mapGetters(['isAuthenticated', 'currentUser']),
    
    isEmailConfirmed() {
      return this.user?.email_confirmed_at || this.user?.confirmed_at || false
    },
    
    displayName() {
      return this.userDisplayName || this.currentUser?.email || 'משתמש'
    }
  },
  methods: {
    ...mapMutations(['CLEAR_TOAST']),
    ...mapActions(['signOut', 'fetchUser']),
    
    clearToast() {
      this.CLEAR_TOAST()
    },
    
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    },
    
    toggleSidebarCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    
    navigateToQuotes() {
      this.navigateTo('/quotes')
    },
    
    navigateTo(route) {
      // Close the sidebar on mobile when navigating
      if (window.innerWidth < 640) {
        this.sidebarOpen = false
      }
      this.$router.push(route)
    },
    
    async handleSignOut() {
      await this.signOut()
      this.$router.push('/login')
    },
    
    async fetchUserProfile() {
      if (!this.isAuthenticated || !this.currentUser) return
      
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('display_name')
          .eq('id', this.currentUser.id)
          .single()
          
        if (error) throw error
        
        this.userDisplayName = data?.display_name || null
      } catch (err) {
        console.error('Error fetching user profile:', err)
        this.userDisplayName = null
      }
    },
    
    async fetchApprovedQuotesCount() {
      if (!this.isAuthenticated || !this.currentUser) return

      try {
        const { count, error } = await supabase
          .from('quotes')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', this.currentUser.id)
          .eq('converted', true) // Only count approved quotes

        if (error) throw error
        
        this.approvedQuotesCount = count || 0
      } catch (err) {
        console.error('Error fetching approved quotes count:', err)
      }
    },
    
    async navigateToAnalytics() {
      if (!this.isAuthenticated || !this.currentUser) return

      try {
        const stats = await subscriptionService.getSubscriptionStats(this.currentUser.id)
        
        // Only premium users can access analytics
        if (stats.subscriptionType !== 'premium') {
          // Redirect to dashboard with upgrade modal for analytics access
          this.$router.push({
            path: '/dashboard',
            query: {
              showUpgrade: 'true',
              reason: 'analytics_access',
              feature: 'analytics'
            }
          })
        } else {
          this.navigateTo('/analytics')
        }
      } catch (err) {
        console.error('Error checking subscription:', err)
        // On error, still try to navigate - the route guard will handle it
        this.navigateTo('/analytics')
      }
    }
  },
  watch: {
    // Update data when auth status changes
    isAuthenticated(newVal) {
      if (newVal) {
        this.fetchApprovedQuotesCount()
        this.fetchUserProfile()
      } else {
        this.approvedQuotesCount = 0
        this.userDisplayName = null
      }
    },
    // Close sidebar when route changes on mobile
    '$route'() {
      if (window.innerWidth < 640) {
        this.sidebarOpen = false
      }
    },
    // Watch for changes in currentUser
    currentUser() {
      if (this.currentUser) {
        this.fetchUserProfile()
      }
    }
  },
  mounted() {
    // Check for existing session on app load
    this.fetchUser()
    
    // Set initial sidebar states
    this.sidebarOpen = false // Start with mobile sidebar closed
    
    // Handle window resize events
    window.addEventListener('resize', () => {
      // No need to set sidebarOpen to true on desktop as it's always visible with sm:translate-x-0
      // Just handle mobile close/open behavior with sidebarOpen
    })
    
    // Listen for profile updates
    window.addEventListener('user-profile-updated', () => {
      this.fetchUserProfile()
    })
    
    // Check for approved quotes and user profile periodically
    this.fetchApprovedQuotesCount()
    this.fetchUserProfile()
    setInterval(this.fetchApprovedQuotesCount, 60000) // Check every minute
    
    // Auto-dismiss toast after 5 seconds
    this.$watch('toastMessage', (newVal) => {
      if (newVal) {
        setTimeout(() => {
          this.CLEAR_TOAST()
        }, 5000)
      }
    })
  }
}
</script>

<style>
/* Tailwind already imported through the main.js file */

/* Transition effects */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

html, body {
  direction: rtl;
}
</style>